import { apiClient } from '_app'
import { ApiResponse, ConformityReadyToSendDto, VehicleDto } from 'dtos'
import { ConformityReadyToSignDto } from 'dtos/conformityReadyToSignDto'
import { ConformitySentToDOTDto } from 'dtos/conformitySentToDOTDto'
import { ConformityReadyToSignVehiclesParameters } from 'parameters'
import { ConformityReadyToSendVehiclesParameters, ConformitySentToDOTVehiclesParameters } from 'parameters/conformityParameters'
import { URIQuery } from 'utils'

export const getConformityReadyToSignVehicles = (parameters: ConformityReadyToSignVehiclesParameters) =>
  apiClient.get<ApiResponse<ConformityReadyToSignDto[]>>(`/api/conformity/ready-to-sign-vehicles` + URIQuery({ ...parameters })).then(response => response.data)

export const createFilesToSign = (vehicleGuids: string[]) =>
  apiClient.post<ApiResponse<void>>(`/api/conformity/create-files-to-sign`, vehicleGuids).then(response => response.data)

export const getConformityReadyToSendVehicles = (parameters: ConformityReadyToSendVehiclesParameters) =>
  apiClient.get<ApiResponse<ConformityReadyToSendDto[]>>(`/api/conformity/ready-to-send-vehicles` + URIQuery({ ...parameters })).then(response => response.data)

// export const downloadConformitySummarySheet = (entryNumber: string) => {
//   return apiClient.get(`/api/conformity/download-conformity-summary-sheet`, {
//     params: { entryNumber },
//     responseType: 'blob'
//   })
// }

export const downloadReadyToSendSummarySheet = (entryNumber: string) => {
  return apiClient.get(`/api/conformity/download-ready-to-send-summary-sheet`, {
    params: { entryNumber },
    responseType: 'blob'
  })
}

export const downloadSentToDOTSummarySheet = (entryNumber: string) => {
  return apiClient.get(`/api/conformity/download-sent-to-dot-summary-sheet`, {
    params: { entryNumber },
    responseType: 'blob'
  })
}

export const previewConformityZip = (vehicleGuid: string) => {
  return apiClient.get(`/api/conformity/preview-conformity-zip/${vehicleGuid}`, {
    responseType: 'blob'
  })
}

export const downloadConformityZip = (vehicleGuid: string) => {
  return apiClient.get(`/api/conformity/download-conformity-zip/${vehicleGuid}`, {
    responseType: 'blob'
  })
}

export const getConformitySentToDOTVehicles = (parameters: ConformitySentToDOTVehiclesParameters) =>
  apiClient.get<ApiResponse<ConformitySentToDOTDto[]>>(`/api/conformity/sent-to-dot-vehicles` + URIQuery({ ...parameters })).then(response => response.data)

export const saveConformityPackageTrackingNumbers = (vehicles: VehicleDto[]) =>
  apiClient.post<ApiResponse<void>>(`/api/conformity/save-conformity-package-tracking-numbers`, vehicles).then(response => response.data)

export const saveAndMarkSelectedAsSentToDOT = (vehicles: VehicleDto[]) =>
  apiClient.post<ApiResponse<void>>(`/api/conformity/save-and-mark-selected-as-sent-to-dot`, vehicles).then(response => response.data)
